import type { Camera } from "../domain/camera";
import { defaultSchedule, holidayShutdownSchedule, weekendMaintenanceSchedule } from "./mock-schedules";

export const mockCameras = (siteId: string): Camera[] => [
  {
    systemId: `${siteId}-sys-1`,
    cameraId: `${siteId}-cam-1`,
    location: "Front Lobby",
    model: "AXIS-Q1798",
    thumbnailUrl: "https://example.com/cameras/front-lobby/thumbnail.jpg",
    liveThumbnailUrl: "https://example.com/cameras/front-lobby/live.jpg",
    capabilities: ["live stream", "event notifications", "site alarm", "audio/video stream"],
    timeZone: "Australia/Sydney",
    strings: {
      alarm_label: "Site alarm",
      notification_label: "Notifications",
    },
    dailyPhotoStartHour: 6,
    isPaused: false,
    isPausible: true,
    schedules: [defaultSchedule, weekendMaintenanceSchedule],
  },
  {
    systemId: `${siteId}-sys-2`,
    cameraId: `${siteId}-cam-2`,
    location: "Warehouse Bay",
    model: "Verkada-D80",
    thumbnailUrl: "https://example.com/cameras/warehouse/thumbnail.jpg",
    liveThumbnailUrl: "https://example.com/cameras/warehouse/live.jpg",
    capabilities: ["live stream", "event search", "daily photos"],
    timeZone: "Australia/Sydney",
    strings: {},
    dailyPhotoStartHour: 7,
    isPaused: true,
    pauseUntilUtc: "2025-02-05T10:00:00Z",
    phonePauseUntilUtc: "2025-02-05T10:00:00Z",
    isPausible: true,
    schedules: [defaultSchedule, holidayShutdownSchedule],
  },
  {
    systemId: `${siteId}-sys-3`,
    cameraId: `${siteId}-cam-3`,
    location: "Car Park Level 2",
    model: "Bosch-FLEXIDOME",
    thumbnailUrl: "https://example.com/cameras/carpark/thumbnail.jpg",
    liveThumbnailUrl: "https://example.com/cameras/carpark/live.jpg",
    capabilities: ["live stream", "alarm unit", "site alarm", "patriot monitoring"],
    timeZone: "Australia/Sydney",
    strings: {
      siren_label: "Car park siren",
    },
    isPaused: false,
    isPausible: false,
    schedules: [defaultSchedule],
  },
];
